import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { forwardRef, useState } from 'react';

const StyledTextField = styled(TextField)({
  input: {
    height: '6px',
    // padding: '14.5px 14px',
    '&:-webkit-autofill  ': {
      // eslint-disable-next-line no-useless-concat
      WebkitBoxShadow: '0 0 0 0 100px ' + '0' + ' inset',
      backgroundColor: '#FFF !important;',
      backgroundClip: 'content-box !important',
    },
  },
  '& .MuiInputBase-root': {
    backgroundColor: '#fff !important',
    borderRadius: '8px',
  },
  '& label.Mui-focused': {
    // color: 'green',
  },
  '& .MuiInput-underline:after': {
    // borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    minHeight: '34px !important',
    '& fieldset': {
      borderRadius: '8px',
      // backgroundColor: '#FFF !important;',
    },
    '&:hover fieldset': {
      // borderColor: 'yellow',
    },
    '&.Mui-focused fieldset': {
      // borderColor: 'green',
    },
  },
  '& .MuiFormLabel-root': {
    top: '-4px',
  },
});

const CustomTextField = forwardRef((props: any, ref) => {
  const {
    label,
    required,
    error,
    helperText,
    variant,
    placeholder,
    disabled,
    fullWidth,
    type,
    value,
    startAdornment,
    labelOverFlow,
    endAdornment,
    ...rest
  } = props;

  //  states
  const [showPassword, setShowPassword] = useState(false);
  // Handlers
  const handleToggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };
  const handleMouseDownPassword = (event: { preventDefault: () => void }) => {
    event.preventDefault();
  };

  return (
    <div>
      <InputLabel
        shrink
        htmlFor="bootstrap-input"
        required={required}
        className="text-lg  font-semibold text-gray-600"
        sx={{ textOverflow: !labelOverFlow ? 'ellipsis' : 'unset' }}
      >
        {label}
      </InputLabel>
      <StyledTextField
        ///   label={label}
        placeholder={placeholder}
        error={error}
        helperText={helperText || null}
        inputRef={ref}
        variant={variant}
        disabled={disabled}
        fullWidth={fullWidth}
        autoComplete={''}
        size="medium"
        value={value}
        /* eslint-disable no-nested-ternary */
        type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
        InputProps={{
          startAdornment: startAdornment || null,
          endAdornment: (
            <>
              {type === 'password' ? (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleToggleShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    size="large"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ) : (
                endAdornment || null
              )}
            </>
          ),
        }}
        {...rest}
      />
    </div>
  );
});

CustomTextField.displayName = 'CustomTextField';

CustomTextField.defaultProps = {
  label: '',
  required: false,
  error: false,
  helperText: '',
  variant: 'outlined',
  disabled: false,
  fullWidth: true,

  type: 'text',
};

export default CustomTextField;
